import { useRef } from 'react';
import { gql } from '@apollo/client';
import { Container, RevealWrapper } from '@components';
import { getHighlightMarkup } from '@/core/utils';

import { useInView } from 'motion/react';
import { useViewSize } from '@/providers/ViewSizeContext';
import { AnimVals } from '@/utils/animUtils';

import styles from './Intro.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

interface IntroProps {
  headline?: string;
  body?: string;
  inducteeDetail?: boolean;
}

export default function Intro({ headline, body, inducteeDetail = false }: IntroProps) {
  const headlineMarkup = getHighlightMarkup(headline);

  // -------------------- Animation

  const rootEl = useRef<HTMLElement>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });

  // -------------------- Render

  return (
    <section className={cx(["intro", { "detail": inducteeDetail }])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        <Container>
          <div className={cx("intro__content")}>
            <h2 className={cx(["headline", "title-lc-m"])} dangerouslySetInnerHTML={{ __html: headlineMarkup }} />
            { body && <div className={cx(["body", "rich-text"])} dangerouslySetInnerHTML={{ __html: body }} /> }
          </div>
        </Container>
      </RevealWrapper>
    </section>
  )
}

Intro.fragments = {
  entry: gql`
    fragment Intro on FlexiblePageContentContentIntroLayout {
      headline
      body
    }
  `
};
